import { Component, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { User } from '../../models/user';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';
declare var $: any;
import { environment } from '../../../environments/environment';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgForm } from '@angular/forms';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { general } from 'src/app/models/general';
import { SolicitudRelampagoComponent } from 'src/app/modales/solicitud-relampago/solicitud-relampago.component';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: [
    './header.component.css',
    '../login/font-awesome/css/font-awesome.min.css',
    '../login/perfect-scrollbar/dist/css/perfect-scrollbar.min.css',
    '../login/css/table.css',
    '../login/css/estilos.css',
    './css/main.css'
  ],
  providers: [UserService]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public url;
  public clock;
  identity: any = {};
  public aportes;
  public token;
  public respuesta: any = '';
  parametrosgenerales: any = [];
  public parametrosgiconos : any = [];
  public user: User;
  message: any;
  mobile: any;
  public ultimaFecha;
  public codasociado;
  public cedulaEncriptada;
  public result = '';
  public characters;
  private minut: number = 0
  private second: number = 1
  private secondLogout: number = 1
  private logoutvar: boolean = true
  actual = environment.actual;
  logo = environment.entidad[this.actual].urlLogo;
  heightLogo = environment.entidad[this.actual].heightLogo;
  public colorMenu = environment.entidad[this.actual].colorMenu;
  public letraColor = environment.entidad[this.actual].letraColor;
  public letraColorEnlace = environment.entidad[this.actual].letraColorEnlace;
  parametrosDesarrollos;
  private TimerSession
  public icon
  public relampago
  public plazos

  urlActualizacion;
  urlSolicitud;
  urlPse;
  urlSolCredito;
  date = new Date();
  time = new Date();
  timer;

  configGeneral

  public cupo: any

  constructor(
    private _userService: UserService,
    public _router: Router,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
  ) {
    this.user = new User(1, '', '', '', '', '', '', 0, 0);
    this.relampago = new general()
    if (this._router.url != '/simulador' && this._router.url != '/afiliacion-form') {
      if (this._userService.GetsessionStorage('token') == '') {
        if (this.actual == 'femhel') {
          window.location.href = 'https://www.femhel.com.co';
        } else {
          this._router.navigate(['salir/1']);
        }
      }

    }
  }

  ngOnInit() {
    this.identity = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.parametrosgenerales = JSON.parse(this._userService.GetsessionStorage('parametrosGenerales'));
    this.parametrosgiconos = JSON.parse(this._userService.GetsessionStorage('iconos'));
    this.configGeneral = JSON.parse(this._userService.GetsessionStorage('config'));
    this.TimerSession = this.configGeneral.general.timer
    this.icon = `<i class="fa fa-bell"></i> Ultima actualización: ` + this.identity.FHAULTIMAACTUALIZACION

    /*this.timer = setInterval(() => {
      this.time = new Date();
    }, 1000);*/

    if (window.screen.width > 768) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }

    this.respuesta = '';
    const user = '';
    if (this.identity != null) {
      const user = btoa(this.identity.USUARIO)
    }
    const session = btoa('actualizafedepalma');

    if (this.configGeneral.general.bloqueapatronal == 'S') {
      this.verify_patronal()
    }


    if (environment.entidad[this.actual].actualizacionLegacy) {
      this.urlActualizacion = `${environment.entidad[this.actual].endPointActualizacion}?id=${user}&varsession=${session}`;
    }
    if (environment.entidad[this.actual].solicitudLegacy) {
      this.urlSolicitud = `${environment.entidad[this.actual].endPointSolicitud}?id=${user}&varsession=${session}`;
    }

    document.addEventListener('mousemove', this.EventMouse);
    this.contadorTimer()

    if (this.configGeneral.general.reqAct == 'S') {

      if (this._router.url != '/actualizacion') {
        this._userService.httpPost('verificaActualizacionIni', { cod: this.identity.CODASOCIADO, codunico: this.identity.CODUNICO }).subscribe(
          (response: any) => {
            if (response.status == 'error') {
              Swal.fire({
                icon: 'info',
                title: 'Actualización requerida!',
                text: 'Señor asociado, se requiere actualizar los datos para visualizar el estado de cuenta',
                showConfirmButton: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  this._router.navigate(['actualizacion'])
                }
              })
            }
          }
        )
      }
    }


    if (this.actual == 'fonreginal' && this._router.url == '/simulador') {
      this._router.navigate(['/home'])
      Swal.fire({
        icon: 'info',
        text: 'Para realizar la simulación de crédito por favor comunicarse al área de cartera al 3182406430 o a los teléfonos 3242405/07 ext 109-112'
      })
    }

    if (this.actual == 'fonasbcol') {
      this.getCupoFobasbcol()
    }
  }

  ngOnDestroy() {
    clearInterval(this.timer);
  }

  getCupoFobasbcol() {
    let data = {}

    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();

    data = {
      codasociado: this.identity.CODASOCIADO,
      codunico: this.identity.CODUNICO,
      nit: this.identity.USUARIO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day,
      recoge: false
    }
    this._userService.httpPost('datosCred', data).subscribe(resp => {
      this.cupo = resp.cupo
      console.log(this.cupo)
    })
  }


  onSubmit(form) {
    this.message = 'Cargando por favor espere';
    const formData = {
      usuario: this.identity.USUARIO,
      password: this.user.password
    };
    this._userService.httpPost('cambiarContrasena', formData).subscribe(
      response => {
        this.respuesta = response;
        this.message = '';
      },
      error => {
        console.log(error as any);
      }
    );
  }

  onAporte(formAporte: NgForm) {
    this.spinner.show()
    formAporte.value.cod = this.identity.CODASOCIADO
    this._userService.httpPost('actAporte', formAporte.value).subscribe(
      (response: any) => {
        this.spinner.hide()
        if (response.status) {
          Swal.fire({
            icon: 'success',
            title: response.details,
            showConfirmButton: false,
            timer: 5000
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Hubo un error',
            showConfirmButton: false,
            timer: 5000
          });
        }
      }
    )
  }

  onAhorro(formAhorro: NgForm) {
    this.spinner.show()
    console.log(formAhorro.value)
    formAhorro.value.cod = this.identity.CODASOCIADO
    this._userService.httpPost('actAhorro', formAhorro.value).subscribe(
      (response: any) => {
        console.log(response)
        this.spinner.hide()
        if (response.status) {
          Swal.fire({
            icon: 'success',
            title: 'Proceso Exitoso!',
            text: response.details,
            showConfirmButton: false,
            timer: 5000
          });
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Hubo un error',
            showConfirmButton: false,
            timer: 5000
          });
        }
      }
    )
  }

  onRelampago(formRelampago: NgForm) {
    $(".closemodalrelampago").click()

    this.spinner.show()
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();

    let data = {
      codasociado: this.identity.CODASOCIADO,
      codunico: this.identity.CODUNICO,
      nit: this.identity.USUARIO,
      fhasta: year + '-' + (monthIndex + 1) + '-' + day,
      recoge: false,
      pse: false
    }

    this._userService.httpPost('cartera', data).subscribe(
      response => {
        let avanza = true;
        if (response.status == 'success') {
          for (let i = 0; i < response.details.length; i++) {
            if (response.details[i].CODLIN == 455) {
              avanza = false;
            }
          }

          console.log(avanza)

          if (avanza) {
            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = true;
            dialogConfig.width = '60%';

            this._userService.httpPost('datosCred', data).subscribe(
              res => {
                if (formRelampago.value.monto <= res.cupo && formRelampago.value.monto <= parseInt(this.configGeneral.simulador.valorRelampago)) {
                  this.spinner.hide()
                  const modalRef = this.dialog.open(SolicitudRelampagoComponent, {
                    autoFocus: false,
                    maxHeight: '80vh', //you can adjust the value as per your view
                    data: { cupo: new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(res.cupo), salario: new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(this.identity.SALARIO), numCuenta: res.cuenta, tipCuenta: res.tipCuenta, telefono: this.identity.TEL1, celular: this.identity.CELULAR }
                  });

                  modalRef.afterClosed().subscribe(resp => {

                    if (resp.data != false) {
                      this.spinner.show()
                      Object.keys(resp.data).forEach(key => {
                        formRelampago.value[key] = resp.data[key]
                      })
                      formRelampago.value.nombre = this.identity.NOMBRES;
                      formRelampago.value.apellido = this.identity.APELLIDOS
                      formRelampago.value.nit = this.identity.USUARIO
                      formRelampago.value.codunico = this.identity.CODUNICO
                      formRelampago.value.codasociado = this.identity.CODASOCIADO
                      formRelampago.value.lineacred = 455
                      this._userService.httpPost('solicitudRelampago', formRelampago.value).subscribe(response => {
                        if (response.status == 'success') {
                          Swal.fire({
                            icon: 'success',
                            text: 'Su solicitud de crédito se ha enviado exitosamente'
                          })
                          this.spinner.hide()
                        } else {
                          Swal.fire({
                            icon: 'error',
                            text: 'No se pudo enviar la solicitud de crédito'
                          })
                          this.spinner.hide()
                        }
                      },
                        error => {
                          console.log(error)
                          this.spinner.hide()
                        })
                    }
                  })
                } else {
                  this.spinner.hide()
                  Swal.fire({
                    icon: 'error',
                    html: 'El monto a solicitar es superior al cupo disponible o supera el valor de desembolso establecido</br> Cupo: ' + new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(res.cupo) + '</br> Maximo desembolso: ' + new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', minimumFractionDigits: 0 }).format(this.configGeneral.simulador.valorRelampago)
                  })
                }
              },
              error => {
                this.spinner.hide()
                console.log(error)
              }
            )

          } else {
            this.spinner.hide()
            Swal.fire({
              icon: 'error',
              text: 'Usted ya cuenta con un credito relampago activo'
            })
          }
        } else {
          this.spinner.hide()
          console.log(response.details)
        }

      },
      error => {
        console.log(<any>error);
        this.spinner.hide()
      }
    )
  }

  plazosRelampago(codlinea) {
    this.spinner.show()
    this._userService.httpGet('plazosCredito/' + codlinea).subscribe(
      response => {
        this.spinner.hide()
        const plazomax = response.PLAZMAX;
        this.plazos = Array();
        for (let i = 1; i <= plazomax; i++) {
          this.plazos.push({
            CODPLAZO: i,
            PLAZO: i
          });
        }
      },
      error => {
        console.log(<any>error);
      }
    );
  }

  navigate2(url) {
    console.log('url', url);
    window.open(url + this.identity.CODASOCIADO + '_2020.pdf', '_blank');
  }

  navigate(url) {
    window.open(url + this.identity.USUARIO + '.pdf', '_blank');
  }

  navigate4(url) {
    window.open(url + this.identity.CODASOCIADO + '.pdf', '_blank');
  }

  navigate3(url) {
    window.open(url, '_blank');
  }

  navigateSolicitudes(url) {
    window.open(url + this.identity.CODASOCIADO, '_blank');
  }

  imprimirEstado() {
    this.spinner.show();
    let date = new Date();
    let day = date.getDate();
    let monthIndex = date.getMonth();
    let year = date.getFullYear();

    let data = { fhasta: year + '-' + (monthIndex + 1) + '-' + day, codasociado: this.identity.CODASOCIADO, codunico: this.identity.CODUNICO, usuario: this.identity.USUARIO }
    this._userService.httpPost('estadoCuenta', data).subscribe(
      (response: any) => {
        if (response.status == 'success') {
          Swal.fire({
            icon: 'success',
            title: 'El estado de cuenta ha sido enviado a su correo'
          }).then(resp => {
            const linkSource = `data:application/pdf;base64,${response.details}`;
            const downloadLink = document.createElement("a");
            const fileName = "EstCuenta" + this.identity.CODASOCIADO + ".pdf";
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: 'No se pudo generar el estado de cuenta',
            text: 'Comuniquese con el admistrador'
          })
        }
        this.spinner.hide();
        console.log("Respuesta imp", response);
        //window.open("https://backend.cyfsoluciones.com/fesolnvo/zonapnvo/ApiFon/zonap/api/"+response,"_blank")
      }, error => {
        console.log(error)
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: 'No se pudo generar el formato pdf'
        })
      }
    )
  }

  PSE(ventanaNueva) {

    if (ventanaNueva == 'S') {
      if (this.actual == 'fsv') {
        window.open("https://www.zonapagos.net/t_ecfondosocialdeviviendadelaregistradur/pagos.asp", '_blank');
      } else {

        this.cedulaEncriptada = this.identity.USUARIO;
        this.codasociado = this.identity.CODASOCIADO;
        this.result = '';
        this.characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 25; i++) {
          this.result += this.characters.charAt(Math.floor(Math.random() * 64));
        }
        if (environment.entidad[this.actual].endPointPse) {
          //this.urlPse = `${environment.entidad[this.actual].endPointPse}?reg_identifica=${this.cedulaEncriptada}&token=${this.result}`;
          //pse fedeaa
          //this.urlPse = `${environment.entidad[this.actual].endPointPse}?reg_identifica=${this.cedulaEncriptada}&cod_asociado=${this.codasociado}`;
          //pse colaborar
          this.urlPse = `${environment.entidad[this.actual].endPointPse}?reg_identifica=${this.cedulaEncriptada}&cod_asociado=${this.codasociado}&token=${this.result}`;
        }

        this._userService.InsertarToken(this.cedulaEncriptada, this.codasociado, this.result).subscribe(
          response => {
            // tslint:disable-next-line:no-conditional-assignment
            if (response.status = 'success') {
              window.open(this.urlPse, '_blank');
            }
          },
          error => {
            console.log(error as any);
          }
        );
      }
    } else {

      if (this.actual == 'fsv') {
        this._router.navigate(['pseFsv']);
      }
      else {
        localStorage.setItem('pse', this.urlPse);
        this._router.navigate(['pagos']);
      }
    }
  }

  solCredito() {
    this.cedulaEncriptada = this.identity.USUARIO;
    this.codasociado = this.identity.CODASOCIADO;
    this.result = '';
    let constini = 'K02S0DER41QW';
    let constfin = 'HGTREDF453SC';
    let nit = '*' + this.cedulaEncriptada + '*';
    nit = constini + nit + constfin;
    nit = btoa(nit);
    nit = constini + nit + constfin;
    nit = btoa(nit);

    /*    this.characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < 25; i++) {
          this.result += this.characters.charAt(Math.floor(Math.random() * 64));
        }*/
    this.urlSolCredito = `http://creditos.fedeaa.com:8081/?c=${nit}`;
    console.log("Url solicitud", this.urlSolCredito);
    window.open(this.urlSolCredito, '_blank');

    /*this._userService.UrlSolicitud(this.cedulaEncriptada).subscribe(
      response => {
        this.urlSolCredito = response;
        console.log("Url solicitud", response);
        window.open(this.urlSolCredito, '_blank');
      },
      error => {
        console.log(error as any);
      }
    );*/
  }

  EventMouse: EventListener = (event: MouseEvent) => {
    this.second = 1;
    this.minut = 0;
  }

  logout() {
    if (this.logoutvar) {
      if (this.secondLogout < 20) {
        this.secondLogout = this.secondLogout + 1;
        setTimeout(() => {
          this.logout();
        }, 1000);
      } else {
        this.secondLogout = 1
        this._router.navigate(['salir/1']);
      }
    }
  }

  contadorTimer() {
    //console.log('segundos', this.second)
    //console.log('minutos', this.minut)
    this.logoutvar = true
    if (this.minut < this.TimerSession) {
      //if (this.minut < 1) {
      if (this.second < 60) {
        this.second = this.second + 1;
      } else {
        this.second = 1;
        this.minut = this.minut + 1
      }
      setTimeout(() => {
        this.contadorTimer();
      }, 1000);
    } else {
      this.logoutvar = false
      this.second = 1;
      this.minut = 0;
      this.logout()
      Swal.fire({
        title: 'Tiempo agotado',
        text: "Señor usuario, ¿Quiere seguir en la sesion actual?",
        icon: 'info',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Salir',
        timer: 10000,
      }).then((result) => {
        console.log(result)
        if (result.isConfirmed) {
          Swal.fire({
            text: 'Ya puede continuar en el estado de cuenta',
            icon: 'success'
          })
          this.second = 1;
          this.minut = 0;
          this.secondLogout = 1;
          this.contadorTimer()
          this.logoutvar = true
        } else {
          if (this.actual == 'femhel' && environment.production) {
            window.location.href = 'https://www..com.co';
          } else {
            if (this._router.url != '/afiliacion-form') {
              this._router.navigate(['salir/1']);
            } else {
              this._router.navigate(['salir/2']);
            }
          }
        }
      })
    }
  }

  verify_patronal() {
    console.log(this.identity)
    let data = {
      codent: this.identity.CODENT
    }

    console.log(data)

    this._userService.httpPost('verify_patronal', data).subscribe(
      (response: any) => {
        if (response.status == 'error') {
          Swal.fire({
            text: response.message,
            icon: 'info',
            allowOutsideClick: false
          }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
              window.location.href = 'https://www.femhel.com.co';
              //window.open('https://www.femhel.com.co');
            }
          })

          //this._router.navigateByUrl('https://www.femhel.com.co');
        }
      }
    )
  }
}
